// Message DELIVERY states — a third status vocabulary, alongside the
// appointment lifecycle (framework `statusColors`) and the clinical-order
// lifecycle (`constants/statuses.js` orderStatusColors). It follows the same
// rule those two follow: colours are DERIVED from the framework tokens, never a
// new hex source, and the words live in the catalogue under a path derived from
// the key.
//
// Deliberately NOT merged into `STATUS` and never rendered through StatusBadge:
// "sent" is a fact about one bubble in a thread, not a chip on a row, and the
// ChatBubble kit component already owns how pending/failed LOOK. This module
// only supplies the icon ink, the soft surface (for any list-level hint), the
// accessible name, and the kit's own status key.
//
// Colour budget: `CT.danger` is for **failed** only. A successful send is the
// ordinary outcome — colouring it green spends an alarm colour on "nothing
// happened", and puts three hues where the reader needs one signal. Sending and
// sent are both quiet; what distinguishes them is the kit's GLYPH (Clock vs.
// Check), because colour is never the only carrier of meaning (§12.4).
import { CT } from '@parsina/framework/tokens';

export const MESSAGE_STATUS = {
  sending: { color: CT.mute,   bg: CT.surface2,   bubble: 'pending', labelKey: 'messages.status.sending' },
  sent:    { color: CT.mute,   bg: CT.surface2,   bubble: 'sent',    labelKey: 'messages.status.sent' },
  failed:  { color: CT.danger, bg: CT.dangerSoft, bubble: 'failed',  labelKey: 'messages.status.failed' },
};

/**
 * A matrix-lite timeline entry → its delivery-state key.
 *
 * The key is the APP's vocabulary («در حال ارسال»); `MESSAGE_STATUS[key].bubble`
 * is the kit's (`pending`). They differ by one word and the mapping lives in
 * the table above so no render file has to remember it.
 */
export const messageStatusOf = (msg) =>
  (msg?.failed ? 'failed' : msg?.pending ? 'sending' : 'sent');
